import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "width900px" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_3 = { class: "margin-left5px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tip_button = _resolveComponent("tip-button")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_message_template_dialog = _resolveComponent("message-template-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.templateList, (item) => {
      return (_openBlock(), _createBlock(_component_tip_button, {
        key: item.ID,
        name: item.Name,
        active: item.ID == _ctx.active,
        onChoose: ($event: any) => (_ctx.choose(item)),
        onEdit: ($event: any) => (_ctx.edit(item)),
        onDelete: ($event: any) => (_ctx.deleteItem(item))
      }, null, 8, ["name", "active", "onChoose", "onEdit", "onDelete"]))
    }), 128)),
    _withDirectives(_createVNode(_component_cus_button, {
      onClick: _ctx.add,
      class: "width200px"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$wordList.ProperAllTextAddTemplate), 1)
      ]),
      _: 1
    }, 8, ["onClick"]), [
      [_vShow, _ctx.templateList.length < 6]
    ]),
    (_ctx.isShowMsgDialog)
      ? (_openBlock(), _createBlock(_component_message_template_dialog, {
          key: 0,
          initForm: _ctx.form,
          submitType: _ctx.submitType,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowMsgDialog = false)),
          onSuccess: _ctx.getMsgTemplate
        }, null, 8, ["initForm", "submitType", "onSuccess"]))
      : _createCommentVNode("", true)
  ]))
}